import { render, staticRenderFns } from "./ListaPreciosComprasComponent.vue?vue&type=template&id=6d80234c&"
import script from "./ListaPreciosComprasComponent.vue?vue&type=script&lang=js&"
export * from "./ListaPreciosComprasComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports